export default "__VITE_ASSET__hVg89ycC__"